import axios from 'axios';
import {downloadFile} from "../../../utils/file/download";

export class ContingencyTrustService {
    getInstructions(
        folio,
        statusContingency,
        counterpart,
        flow) {
        return axios.get('/fideicomiso/contingency/screen', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: folio,
                statusContingency: statusContingency,
                counterpart: counterpart,
                flow: flow
            }
        }).then(res => res.data);
    }

    getFileContingency(keys) {
        return axios({
            url: '/fideicomiso/contingency/getFile',
            method: 'GET',
            responseType: 'blob',
            params: {
                keys: keys.toString(),
                username: localStorage.getItem('username')
            }
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ContingenciaFideicomiso.xls');
            document.body.appendChild(link);
            link.click();
        })
    }

    getContingencyInstructionsBbva(loanId, counterpartObj, eventTypeObj, statusObj) {
        return axios.get('/fiduciario/instruction/contingency', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                loanId: loanId ? loanId : 0,
                counterpartId: counterpartObj.institutionId ? counterpartObj.institutionId : 0,
                eventType: eventTypeObj.instructionId ? eventTypeObj.instructionId : "",
                status: statusObj.statusName ? statusObj.statusName : "",
            }
        }).then(res => res.data);
    }
    getContingencyLayoutTXT(params){
        return downloadFile('/fiduciario/instruction/contingency/txt-format', params);
    }

    sendInstruction(referencePv){
        return axios.post('/fiduciario/instruction/send', {}, {
            params: {
                referencePv: referencePv ? referencePv : "",
            }
        }).then(res => res.data);

    }

    sendAuthInstruction(trustReferenceId){
        return axios.post('/fiduciario/instruction/auth', {}, {
            params: {
                trustReferenceId: trustReferenceId ? trustReferenceId : "",
            }
        }).then(res => res.data);

    }

    sendSettleInstruction(referencePv, user){
        return axios.post('/fiduciario/instruction/settle', {}, {
            params: {
                referencePv: referencePv ? referencePv.toString() : "",
                user: user ? user : "",
            }
        }).then(res => res.data);
    }

    updateInstitutions(){
        return axios.put('/fiduciario/institutions/updateCatalog', {}, {})
            .then(res => { return res.data});
    }

}